import { LessonProblem } from '@yandex-int/k-common/typings';
// @ts-ignore
import { getIsContentManager } from 'platform-components/src/components/user/selectors';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMedia } from 'react-use';

import { ProblemViewProblemBarContainer } from 'common.components/lesson-view.problem-view/__problem-bar/problem-view__problem-bar.container';
import { PROBLEM_RUN_QUERY_MOBILE } from 'common.components/problem-run/constants';
import { ProblemRun, type SetMarkerProps } from 'common.components/problem-run/problem-run';
import { actions } from 'store/problems-view/actions';
import * as problemsViewSelectors from 'store/problems-view/selectors';
import { isOpenAnswer, isTheory } from 'store/problems/utils';

interface Props {
    problemLink: LessonProblem | null;
    selectedProblemId: number | null;
}

export const StackModalProblem = ({ problemLink, selectedProblemId }: Props) => {
    const isMobile = useMedia(PROBLEM_RUN_QUERY_MOBILE);

    const dispatch = useDispatch();

    const isAnswered = useSelector(problemsViewSelectors.getIsAnswered);
    const problemAttempt = useSelector(problemsViewSelectors.getProblemAttempt);
    const shouldShowCorrectAnswers = useSelector(problemsViewSelectors.getShouldShowCorrectAnswers);
    const shouldShowProblemId = useSelector(getIsContentManager);
    const setMarkerAnswer = useCallback(
        (answer: SetMarkerProps) => dispatch(actions.setMarkerAnswer(answer)),
        [dispatch]
    );

    const readonly = isMobile || isAnswered;
    const problem = problemLink?.problem || null;
    const shouldShowAnswerControls = !isTheory(problem) && !isOpenAnswer(problem);

    return (
        <ProblemRun
            isAnswered={isAnswered}
            mix="stack-modal__problem-run"
            problemAttempt={problemAttempt}
            problemLink={problemLink}
            readonly={readonly}
            selectedProblemId={selectedProblemId}
            setMarkerAnswer={setMarkerAnswer}
            shouldShowCorrectAnswers={shouldShowCorrectAnswers}
            shouldShowProblemId={shouldShowProblemId}
        >
            {shouldShowAnswerControls && <ProblemViewProblemBarContainer />}
        </ProblemRun>
    );
};
